module.exports = global["Vue"] = require("-!/Users/debraohayon/Sites/housingworks/node_modules/vue/dist/vue.common.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Vue!./~/vue/dist/vue.common.js
// module id = 294
// module chunks = 0